import { createFileRoute, redirect } from "@tanstack/react-router";

// URL antigua: redirección permanente a la ruta limpia.
export const Route = createFileRoute("/subvenciones/")({
  beforeLoad: () => {
    throw redirect({ to: "/recursos/subvenciones", statusCode: 301 });
  },
});
